import { useContext } from "react";
// context
import Context from "src/contexts/auth/authContext";

export type TokensPayload = {
	token: string;
	refreshToken: string;
};

export const defaultAuth: ReturnType<typeof useAuth> = {
	signIn: () => {},
	signOut: () => {},
	getRefreshToken: () => null,
	isAuthenticated: false,
	isInitialized: false,
	token: null,
	refreshToken: null
};

export const defaultAuthRoute: AuthRouteContext = {
	isAuthenticated: false,
	isInitialized: false,
	token: null,
	refreshToken: null
};

export const useAuth = () => {
	const { state, actions } = useContext(Context);

	const signIn = (tokens: TokensPayload) => {
		actions.signIn(tokens);
	};

	const signOut = () => {
		actions.signOut();
	};

	const getRefreshToken = () => {
		return state.refreshToken;
	};

	return {
		signIn,
		signOut,
		getRefreshToken,
		isAuthenticated: state.isAuthenticated,
		isInitialized: state.isInitialized,
		token: state.token,
		refreshToken: state.refreshToken
	};
};

export type AuthContext = ReturnType<typeof useAuth>;

export type AuthRouteContext = {
	isAuthenticated: boolean;
	isInitialized: boolean;
	token: string | null;
	refreshToken: string | null;
};
